import http from '../http'

export default {
  // 获取用户详情
  getPfUserDetail(data: object, option: object = {}) {
    return http.post('/crm/pf_user/detail', data, option)
  },
  // 更新用户详情
  updatePfUserDetail(data: object, option: object = {}) {
    return http.post('/crm/pf_user/update', data, option)
  },
  //  获取用户地址
  getPfUserAddress(data: object, option: object = {}) {
    return http.post('/crm/pf_user/address/query', data, option)
  },
  // 更新用户地址
  updatePfUserAddress(data: object, option: object = {}) {
    return http.post('/crm/pf_user/address/update', data, option)
  },
}
